<template>
    <div class="add-inventory">
        <van-cell-group style="margin-bottom: 10px;" class="group2" inset>
            <van-cell :value="provinceName" class="inputone" title="省份" required is-link  @click="showProvince = true">
                <template>
                    <div :style="{'color':provinceName=='请选择'?'#969799':'black'}">{{provinceName}}</div>
                </template>
            </van-cell>
            <van-popup  v-model="showProvince" round  position="bottom">
                <van-picker show-toolbar :columns="provinceArr" @cancel="showProvince = false" @confirm="confirmProvince" />
            </van-popup>

            <van-cell :value="cityName" class="inputone" title="城市" required is-link  @click="openCity">
                <template>
                    <div :style="{'color':cityName=='请选择'?'#969799':'black'}">{{cityName}}</div>
                </template>
            </van-cell>
            <van-popup v-model="showCity" round  position="bottom">
                <van-picker show-toolbar :columns="cityArr" @cancel="showCity = false" @confirm="confirmCity" />
            </van-popup>

            <van-cell :value="drugstore" class="inputone" title="药房" required is-link  @click="showDrugstore=true">
                <template>
                    <div :style="{'color':drugstore=='请选择'?'#969799':'black'}">{{drugstore}}</div>
                </template>
            </van-cell>
            <van-popup v-model="showDrugstore" round  position="bottom">
                <van-picker show-toolbar :columns="drugstoreArr" @cancel="showDrugstore = false" @confirm="confirmDrugstore" value-key="name" />
            </van-popup>

            <van-cell :value="inventoryTimeStr" class="inputone" title="盘点日期" required is-link  @click="showDatePicker=true">
            <template>
                <div :style="{'color':inventoryTimeStr=='请选择'?'#969799':'black'}">{{inventoryTimeStr}}</div>
                </template>
            </van-cell>
            <van-popup v-model="showDatePicker" round position="bottom">
                <van-datetime-picker v-model="inventoryDate" type="date" title="" :min-date="minDate" :max-date="maxDate" @confirm="confirmInventoryDate" @cancel="showDatePicker=false"/>
            </van-popup>
            <van-cell :value="drugType" class="inputone" title="药品" required is-link  @click="showdrugType=true">
                <template>
                    <div :style="{'color':drugType=='请选择'?'#969799':'black'}">{{drugType}}</div>
                </template>
            </van-cell>
            <van-popup v-model="showdrugType" round  position="bottom">
                <van-picker show-toolbar :columns="drugTypeArr" @cancel="showdrugType = false" @confirm="confirmDrugType" />
            </van-popup>

        </van-cell-group>

         <van-cell-group style="margin-bottom: 10px;" class="group2" inset v-for="item,index in items" :key="index">
            <van-cell :value="item.batchNumber" class="inputone" title="药品批号" required is-link  @click="clickBatchNumber(item,index)">
                <template>
                    <div :style="{'color':item.batchNumber=='请选择'?'#969799':'black'}">{{item.batchNumber}}</div>
                </template>
            </van-cell>
            <van-popup v-model="showbatchNumber" round  position="bottom">
                <van-picker show-toolbar :columns="batchNumberArr" @cancel="showbatchNumber = false" @confirm="confirmBatchNumber" value-key="sn"/>
            </van-popup>
            <van-field v-model="item.firmQuantity" required label="实盘数量" type="number" placeholder="实盘数量" input-align="right" label-class="black-label"  />
            <van-cell title="" class="align-right"  @click="addBatchNumber()"  v-if="index==items.length-1">
                <van-button type="primary" color="#0AA8AF">新增批号</van-button>
            </van-cell>
            <van-cell title="" class="align-right"  @click="deleteBatchNumber(index)" v-else>
                <van-button type="warning" >删除批号</van-button>
            </van-cell>
        </van-cell-group>

        <van-cell-group style="margin-bottom: 10px;" class="group2" inset>
            <van-cell>
                <template #title>
                    <div >盘点现场照片</div>
                    <image-uploader ref="imgUploader" :value="photoArr" @input="getPhoto" title=" " :num="9" @deleteCI="deleteCI" ></image-uploader>
                </template>
            </van-cell>
        </van-cell-group>

        <div class="checkin-btn">
            <van-button @click="next()"  type="info" round block color="#0AA8AF" :disabled="submitBtnDisabled">提交</van-button>
        </div>
	</div>
</template>
<script>
  import Vue from 'vue';
  import {
    mapState
  } from "vuex";
  import {
    Toast,
  } from 'vant';
      import { 
      getVolunteerProvinceCity,
      getDrugstoreStock,
      getDrug,
      createDrugstoreTake
  } from '@/api/publicWelfareStaff' 
      import {
    GetDrugstore,
  } from "@/api/api";
import ImageUploader from "@/views/publicWelfareStaff/ImageUploader";
  Vue.use(Toast);
export default {
    components: {ImageUploader},
	data(){
		return {
            items:[
                {batchNumber:'请选择',firmQuantity:'',stock_id:''}
            ],
            //省份
            provinceName:'请选择',
            showProvince:false,
            provinceArr:[],
            //城市
            cityName: '请选择',
            showCity: false,
            cityArr: [],

            //药房
            drugstore:'请选择',
            showDrugstore:false,
            drugstoreArr:[],
            //盘点日期
            showInventoryDate:false,
            inventoryTimeStr:'请选择',
            inventoryDate:new Date(),
            showDatePicker:false,
            minDate: new Date(1949, 10, 1),
            maxDate: new Date(),
            //药品
            drugType:'请选择',
            showdrugType:false,
            drugTypeArr:[],
            //药品批号
            batchIndex:'',//当前药品批号组件的index
            batchNumber:'请选择',
            showbatchNumber:false,
            batchNumberArr:[],
            //实盘数量
            firmQuantity:'',
            //盘点现场照片 
            photoArr:[],

            provinceCity:{},//省份城市数据

            submitBtnDisabled:false,
		}
	},
	async created() {
        Toast.loading({
                duration: 0, // 持续展示 toast
                overlay: true,
                forbidClick: true
            });
        await this.init()
        Toast.clear();
	},
    computed:{
        ...mapState(['publicWelfareStaff']),
    },
	methods:{
        async init(){
            await getVolunteerProvinceCity({ 
                volunteer_id:this.publicWelfareStaff.checkin_info.papid
            }).then(res => {
                this.provinceArr = Object.keys(res.data)
                this.provinceCity=res.data
            })
            await getDrug().then(res => {
                if(res.data){
                    this.drugTypeArr=[]
                    console.log("药品:",res.data)

                    this.drugTypeArr.push(res.data[1])
                }
            }).catch(err => {
                Toast(err.response.data.message)
            })
        },

        timeFormat(time) {
            let year = time.getFullYear();
            let month = time.getMonth() + 1;
            let day = time.getDate();
            return year + '-' + month + '-' + day;
        },
        confirmProvince(value){
            // 选中省份 
            this.provinceName=value
            this.cityName="请选择"
            this.drugstore = "请选择"
            this.cityArr=[]
            this.hospitalArr =[]
            this.showProvince = false

            this.cityArr=this.provinceCity[this.provinceName]
        },
        openCity() {
            if (this.cityArr.length < 1) {
                Toast('请先选择“所属省份”')
                return
            }
            this.showCity = true
        },
        async confirmCity(value){
            // console.log("!",value)
            this.cityName=value
            this.hospitalName = "请选择"
            this.hospitalArr =[]
            this.showCity = false

            Toast.loading({
                duration: 0, // 持续展示 toast
                overlay: true,
                forbidClick: true
            });
            let hres = await GetDrugstore({
              province: this.provinceName,
              city: this.cityName
            })
            // console.log(hres.data)
            let drugstoreArr=[]
            hres.data.forEach(ele=>{
                drugstoreArr.push(ele)
            })
            this.drugstoreArr = drugstoreArr
            if (this.drugstoreArr.length < 1) {
              this.drugstoreArr.unshift({ name:'该城市下暂无项目药房' })
            }
            Toast.clear();
        },
        ondrugstore(){
            if (this.drugstoreArr.length < 1) {
                Toast('请先选择“城市”')
                return
            }
            this.showDrugstore=true
        },
        async confirmDrugstore(value){
            this.drugstore=value.name
            this.drugstore_id=value.id
            this.showDrugstore = false
            if(this.drugstore=='该城市下暂无项目药房') {
                Toast('该城市下暂无项目药房')
                return
            }

            Toast.loading({
                duration: 0, // 持续展示 toast
                overlay: true,
                forbidClick: true
            });
            let hres = await getDrugstoreStock({
              drugstore_id: this.drugstore_id,
            })
            console.log("getDrugstoreStock返回:",hres.data)
            let batchNumberArr=[]
            hres.data.forEach(ele=>{
                batchNumberArr.push(ele)
            })
            this.batchNumberArr = batchNumberArr
            if (batchNumberArr[0]) this.drug_id=batchNumberArr[0].drug_id//取了第一个药品的药品id,因为drug_id字段出现在getDrugstoreStock的返回里
            if (this.batchNumberArr.length < 1) {
              this.batchNumberArr.unshift({ sn:'该药房下暂无药品批号' })
            }
            Toast.clear();
            

        },
        confirmInventoryDate(value){
            console.log("盘点时间",value)
            this.inventoryTimeStr=this.timeFormat(value)
            this.showDatePicker=false;
        },
        confirmDrugType(value){
            this.drugType=value
            this.showdrugType = false
        },
        clickBatchNumber(item,index){
            if (this.batchNumberArr.length < 1) {
                Toast('请先选择“药房”')
                return
            }
            this.batchIndex=index
            this.showbatchNumber=true
        },
        confirmBatchNumber(value){
            console.log("批号和序号:",value,this.batchIndex)
            console.log("this.items",this.items)
            this.items[this.batchIndex].batchNumber=value.sn
            this.items[this.batchIndex].stock_id=value.ary_stock_id
            this.showbatchNumber = false
        },
        addBatchNumber(){
            this.items.push({batchNumber:'请选择',firmQuantity:'',stock_id:''})
        },
        deleteBatchNumber(index){
            this.items.splice(index, 1)
        },





        getPhoto(image){
            console.log("input-get",image)
        },
        deleteCI(){
            Dialog.confirm({
                message: '确定删除？',
            })
            .then(() => {
                // this.photo=[]
            })
        },

		toastText(text){
			Toast(text)
		},
		async next(){
            
            // console.log("publicWelfareStaff.originRoute:",this.publicWelfareStaff.originRoute)
            if(this.provinceName=="请选择"){
                Toast("省份不得为空!")
                return
            }
            if(this.cityName=="请选择"){
                Toast("城市不得为空!")
                return
            }

            if(this.drugstore=="请选择"){
                Toast("药房不得为空!")
                return
            }
            if(this.inventoryTimeStr=="请选择"){
                Toast("盘点日期不得为空!")
                return
            }
            if(this.drugType=="请选择"){
                Toast("药品不得为空!")
                return
            }
            let temp=[]
            for(let i in this.items){
                if(temp.length==0){
                    temp.push(this.items[i].batchNumber)
                }else{
                    if(temp.indexOf(this.items[i].batchNumber) != -1){
                        Toast("药品批号不能相同!")
                        return
                    }else{
                        temp.push(this.items[i].batchNumber)
                    } 
                }
                // console.log("parseInt(this.items[i].firmQuantity)",parseInt(this.items[i].firmQuantity))
                if(this.items[i].batchNumber=="请选择"||this.items[i].batchNumber=="该药房下暂无药品批号"){
                    Toast("药品批号不得为空!")
                    return
                }
                if(!this.items[i].firmQuantity||parseInt(this.items[i].firmQuantity)<=0){
                    Toast("实盘数量必须大于0!")
                    return
                }
            }
            let detail=[]
            // console.log("!!!",this.items)
            console.log("photoArr",this.photoArr)
            // 将图片的src传给接口
            let images_arr = []
            for(let i in this.photoArr){
                images_arr.push(this.photoArr[i].src)
            }
            console.log("images_arr",images_arr)
            this.items.forEach(item =>{
                 detail.push({
                     stock_id:item.stock_id,
                     quantity:item.firmQuantity
                 })
            })
            let sendData={
                volunteer_id:this.publicWelfareStaff.checkin_info.papid,
                province: this.provinceName,
                city: this.cityName,
                take_date:this.timeFormat(new Date),
                drugstore_id:this.drugstore_id,
                drug_id:this.drug_id,
                drugstore_take_images:images_arr,
                detail:detail,
            }
            console.log("createDrugstoreTake发送数据:",sendData)
            this.submitBtnDisabled=true
            await createDrugstoreTake(sendData).then(res => {
                if(res.data){





                    this.$router.replace({
                        name: "staffMsg",
                        query:{
                            title:'提交成功',
                            btnText:'返回盘点库存页',
                            statusText:'新增盘点库存成功',
                            notice:'',
                            // route:this.publicWelfareStaff.originRoute
                        }
                    })
                }
            })
            this.submitBtnDisabled=false

		},

	}
};
</script>

<style lang="less" scoped>
.add-inventory {
	font-size: 16px;
    min-height: 100vh;
    background-color: #f9f9f9;
    padding-top: 15px;
    .group2{
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
        .van-cell__value{
            flex:1.5 0 !important;
        }
        
    }
	.checkin-btn {
      margin: 25px;
    }
    /deep/ .noborder.van-cell::after{
      border-bottom:none !important;
    }



    ::v-deep .black-label{
        span{
            color:#323233;
        }
    }
    ::v-deep .grey-label{
        color:#9D9D9D;
        white-space:nowrap;
    }
}
</style>